<template>
  <v-main>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <Header :title="'Calendar'" />
              <v-card-text>
                <template>
           
                  <v-row class="fill-height">
                    <v-col>
                      <v-sheet height="64">
                        <v-toolbar
                          flat
                        >
                          <v-btn
                            outlined
                            class="mr-4"
                            color="grey darken-2"
                            @click="setToday"
                          >
                            {{'Today' | translate}}
                          </v-btn>
                          <v-btn
                            fab
                            text
                            small
                            color="grey darken-2"
                            @click="prev"
                          >
                            <v-icon small>
                              mdi-chevron-left
                            </v-icon>
                          </v-btn>
                          <v-btn
                            fab
                            text
                            small
                            color="grey darken-2"
                            @click="next"
                          >
                            <v-icon small>
                              mdi-chevron-right
                            </v-icon>
                          </v-btn>
                          <v-toolbar-title v-if="$refs.calendar">
                            {{ getCalendarDate($refs.calendar.title) }}
                          </v-toolbar-title>

                          <v-select
                            v-model="calendarsSelected"
                            :items="calendars"
                            item-value="id"
                            item-text="name"
                            :label="'Calendars' | translate"
                            @change="calendarsUpdated()"
                            class="ml-6 mt-7"
                            style="max-width:550px;"
                            multiple
                            outlined
                            dense
                          >

                          <template v-slot:item="{item, on, attrs}">
                            <v-list-item v-on="on">
                              <v-list-item-action>
                                <v-simple-checkbox
                                  :value="attrs.inputValue"
                                  v-on="on"
                                  :color="item.hexColor?item.hexColor:'primary'"
                                  :ripple="false"
                                ></v-simple-checkbox>
                              </v-list-item-action>
                              <v-list-item-content>
                                <v-list-item-title>
                                  {{ getCalendarName(item.name) }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </v-list-item>
                          </template>

                            <template v-slot:selection="{ item, index }">
                                <v-chip :color="item.hexColor?item.hexColor:item.color?item.hexColor?item.hexColor:item.color:item.color" small v-if="index < 2">{{ item.name }}</v-chip>
                                <v-chip
                                  small
                                  v-if="index === 2"
                                  class="text-grey text-caption align-self-center"
                                >
                                  (+{{ calendarsSelected.length - 2 }} others)
                                </v-chip>
                            </template>
                          </v-select>

                          <v-checkbox
                            v-model="personalCalendar"
                            :label="'Personal Calendar' | translate"
                            class="ml-4 mt-7"
                            @change="filterMyEvents()"
                          ></v-checkbox>
                          <v-spacer></v-spacer>

                          <v-menu
                            bottom
                            right
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                outlined
                                color="grey darken-2"
                                v-bind="attrs"
                                v-on="on"
                              >
                                <span>{{ typeToLabel[type] | translate }}</span>
                                <v-icon right>
                                  mdi-menu-down
                                </v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item @click="type = 'day'">
                                <v-list-item-title>{{'Day' | translate}}</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="type = 'week'">
                                <v-list-item-title>{{'Week' | translate}}</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="type = 'month'">
                                <v-list-item-title>{{'Month' | translate}}</v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="type = '4day'">
                                <v-list-item-title>{{'4 days' | translate}}</v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-toolbar>
                      </v-sheet>
                      <v-sheet height="600">
                        <v-calendar
                          ref="calendar"
                          v-model="lmscalendar"
                          color="primary"
                          :events="events"
                          :value-zone="timezone"
                          :event-color="getEventColor"
                          :type="type"
                          @click:event="showEvent"
                          @click:more="viewDay"
                          @click:date="viewDay"
                          @change="updateRange"
                        ></v-calendar>

                        <v-menu
                          v-model="selectedOpen"
                          :close-on-content-click="false"
                          :activator="selectedElement"
                          offset-x
                        >
                          <v-card
                            color="grey lighten-4"
                            min-width="350px"
                            flat
                          >
                            <v-toolbar
                              :color="selectedEvent.color"
                              dark
                            >
                              <v-toolbar-title> {{ selectedEvent.subject}} ( {{  getCalendarName(selectedEvent.calendarName)}} )</v-toolbar-title>
                              <v-spacer></v-spacer>
                            </v-toolbar>
                            <v-card-text  v-if="!isOpenEvent(selectedEvent)">
                              <v-alert
                                color="orange"
                                dense
                                dismissible
                                outlined
                                shaped
                                text
                              >
                              <v-icon color="orange">mdi-warning </v-icon> {{'You are viewing an expired event!' | translate}}
                              </v-alert>
                            </v-card-text>

                            <v-card-text>
                              <v-alert
                                v-if="isOpenEvent(selectedEvent) && selectedEvent.response_status"
                                color="primary"
                                dense
                                dismissible
                                outlined
                                shaped
                                text
                              >
                              <v-icon color="primary">mdi-info </v-icon> {{'You have joined this event. Below are details of the event.' | translate}}
                              </v-alert>
                              <p>
                              <v-icon class="mr-2">mdi-clock-time-three-outline</v-icon>{{ convertDate(selectedEvent.start) }} {{ getTimeSlot(selectedEvent.start, selectedEvent.end) }}
                              <v-btn
                                class="white--text" 
                                color="red"
                                outlined
                                rounded
                                small
                                @click="unsubscribe(selectedEvent.id)"
                                v-if="isOpenEvent(selectedEvent) && selectedEvent.response_status"
                              >
                                {{'Cancel Participation' | translate}}
                              </v-btn>
                              </p>
                            </v-card-text>

                            <v-card-text v-if="selectedEvent.body">
                              <span v-html="selectedEvent.body.content"></span>
                            </v-card-text>
                            
                            <v-card-actions>

                              <span 
                                v-if="selectedEvent.response_status=='accepted'"
                                class="custom-button accepted-button"
                                >
                                {{ 'ACCEPTED'| translate }}
                              </span>
                              <span 
                                v-if="selectedEvent.response_status=='accepted'"
                                class="custom-button declined-button"
                                >
                                {{ 'DECLINED'| translate }}
                              </span>

                              <v-btn
                                class="white--text" 
                                color="blue"
                                @click="joinEvent(selectedEvent.id)"
                                v-if="isOpenEvent(selectedEvent) && !selectedEvent.response_status && selectedEvent.calendartype!='down-time' && selectedEvent.calendartype!='course-expiry' "
                              >
                                {{'Join' | translate}}
                              </v-btn>

                              <v-btn
                                class="white--text" 
                                color="grey darken-2"
                                @click="selectedOpen = false"
                                v-if="isOpenEvent(selectedEvent)"
                              >
                                {{'Close' | translate}}
                              </v-btn>
                              <v-btn
                                class="white--text" 
                                color="grey darken-2"
                                @click="selectedOpen = false"
                                v-if="!isOpenEvent(selectedEvent)"
                              >
                                {{'Close' | translate}}
                              </v-btn>

                              <v-btn
                                class="white--text" 
                                color="grey darken-2"
                                v-if="this.currentUser.roles.includes(1) && isOpenEvent(selectedEvent) && !checkAlreadyAdded(selectedEvent)"
                                @click="openParticipationCountModal(selectedEvent)"
                              >
                                {{'Add Participant limit' | translate}}
                              </v-btn>
                            </v-card-actions>
                          </v-card>
                        </v-menu>
                      </v-sheet>
                    </v-col>
                  </v-row>
                </template>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="participationDialog" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ "Add Participation Count"| translate }}</v-card-title>
        <v-card-subtitle>{{ "How many members can attend this event?"| translate }}</v-card-subtitle>
        <v-card-text>

            <v-text-field
              outlined
              type="number"
              :label="'Participation count' | translate"
              v-model="attendee_limit"
              name="attendee_limit"
              autocomplete="off"
              :rules="limitcountRules"
              required
            >
            <template #message="{ message }">
              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
            </template>
            </v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          
          <v-btn color="success darken-1" text @click="addAttendeeLimit(true)" v-if="ms_event.seriesMasterId!=null">{{ 'Add for all series' | translate }}</v-btn>
          <v-btn color="success darken-1" text @click="addAttendeeLimit(false)">{{ 'Add for event' | translate }}</v-btn>
          <v-btn color="primary darken-1" text @click="participationDialog = false">{{ 'Close'| translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="join_success_dialog" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ "Email Sent"| translate }}</v-card-title>
        <v-card-subtitle>{{ "Thank you for joining the event. An invitation has been send to your e-mail address."| translate }}</v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="reloadPage(); join_success_dialog = false">{{ 'Reload Calendar' | translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="cancel_success_dialog" persistent max-width="560">
      <v-card>
        <v-card-title class="headline">{{ "Unsubscribed from event"| translate }}</v-card-title>
        <v-card-subtitle>{{ "You have been successfully unsubscribed from the event."| translate }}</v-card-subtitle>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary darken-1" text @click="reloadPage(); cancel_success_dialog = false">{{ 'Reload Calendar' | translate }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="calendardialogLoader"
      hide-overlay
      persistent
      width="400"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{'Loading Events. Please stand by...' | translate}}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-overlay :value="isLoading">
      <v-layout row justify-center v-if="isLoading">
        <v-dialog v-model="loadingdata" persistent fullscreen content-class="loading-dialog">
          <v-container fill-height>
            <v-layout row justify-center align-center>
              <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
      </v-layout>
    </v-overlay>

  </v-main>
</template>
<script>
import {
  RESET_STATE,
  FETCH_CALENDARS,
  FETCH_CALENDAR_EVENTS,
  FETCH_ALL_CALENDAR_EVENTS,
  JOIN_CALENDAR_EVENT,
  UNSUBSCRIBE_CALENDAR_EVENT,
  ADD_ATTENDEE_LIMIT
} from "@/store/actions.type";
import { SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"

import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"

export default {
    name:"Calendar",
    async beforeRouteUpdate(to, from, next) {
        await store.dispatch(RESET_STATE);
        return next();
    },
    async beforeRouteEnter(to, from, next) {
        store.commit(SET_ROUTER_ENTER, false)
        return next();
    },
    async beforeRouteLeave(to, from, next) {
        await store.dispatch(RESET_STATE);
        next();
    },
    computed: {
        ...mapGetters(['calendars','calendarevents','currentUser','curLanguage','loadingdata']),
        ...mapState({
        errors: state => state.calendars.calendarerrors
        }),
      getItemIndex() {
        // Create a computed property to get the index of the item in the array
        return (item) => this.calendars.indexOf(item);
      },
      limitcountRules(){ return [v => !!v || "Participation Count is required"]},
    },
    async created() {
      await store.dispatch(FETCH_CALENDARS, '');
    },
    data: function() {
        return {
          primarycolor: "#1976D2FF",
          timezone: 'UTC',
          title: "Calendar",
          calendarsSelected:null,
          lmscalendar: '',
          type: 'month',
          typeToLabel: {
            month: 'Month',
            week: 'Week',
            day: 'Day',
            '4day': '4 Days',
          },
          selectedEvent: {},
          selectedElement: null,
          selectedOpen: false,
          events: [],
          join_success_dialog:false,
          cancel_success_dialog: false,
          isLoading:false,
          calendardialogLoader:false,
          allEventsCalendar: true,
          personalCalendar: false,
          participationDialog:false,
          attendee_limit: null,
          ms_event_id:null,
          ms_event:{},
        }
    },
    components: {
      Header: () => import("@/components/header/Header"),
    },
    methods: {
      async joinEvent(eventId){
        this.selectedOpen = false;
        this.isLoading = true;
        await this.$store
        .dispatch(JOIN_CALENDAR_EVENT, eventId).then(resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.join_success_dialog = true;
            this.$store.commit(SET_LOADING, false)
            this.isLoading = false;
          }
        });
      },
      async unsubscribe(eventId){
        this.selectedOpen = false;
        this.isLoading = true;
        await this.$store
        .dispatch(UNSUBSCRIBE_CALENDAR_EVENT, eventId).then(resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.cancel_success_dialog = true;
            this.$store.commit(SET_LOADING, false)
            this.isLoading = false;
          }
        });
      },
      async reloadPage(){
        location.reload();
      },
      getTimeSlot(start,end){
        const startTime = new Date(start);
        const endTime = new Date(end);

        const startHours = startTime.getHours().toString().padStart(2, '0');
        const startMinutes = startTime.getMinutes().toString().padStart(2, '0');

        const endHours = endTime.getHours().toString().padStart(2, '0');
        const endMinutes = endTime.getMinutes().toString().padStart(2, '0');

        return `${startHours}:${startMinutes} to ${endHours}:${endMinutes}`;
      },
      async calendarsUpdated(){
        const startDate = this.$refs.calendar.lastStart.date;
        const endDate = this.$refs.calendar.lastEnd.date;

        this.$store.commit(SET_LOADING, true)
        this.join_success_dialog = false;
        this.isLoading = true;
        if(this.calendarsSelected){
          await this.$store
          .dispatch(FETCH_CALENDAR_EVENTS, "?calendar_ids=" + this.calendarsSelected+"&start_date="+startDate+"&end_date="+endDate).then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              this.resolveEventObject(resp.data);   
            }
          });
        }
        else{
          await store.dispatch(FETCH_ALL_CALENDAR_EVENTS, '?start_date='+startDate+'&end_date='+endDate).then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              this.events = resp.data;
              this.resolveEventObject(resp.data);
            }
          });
        }

        if(this.personalCalendar){
          this.events = this.events.filter(data => data.attendees.length > 0);
        }

        this.$store.commit(SET_LOADING, false)
        this.isLoading = false;
      },
      async updateRange ({ start, end }) {
        this.calendardialogLoader = true;

        //check for url parms
        const urlSearchParams = new URLSearchParams(window.location.search);
        const calendar_ids = urlSearchParams.get('calendar_ids');
        if(calendar_ids){
          this.calendarsSelected = calendar_ids;
        }

        if(this.calendarsSelected){
          await this.$store
          .dispatch(FETCH_CALENDAR_EVENTS, "?calendar_ids=" + this.calendarsSelected+"&start_date="+start.date+"&end_date="+end.date).then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              this.events = resp.data;
              this.resolveEventObject(resp.data);   
            }
          });
        }
        else{
          await store.dispatch(FETCH_ALL_CALENDAR_EVENTS, '?start_date='+start.date+'&end_date='+end.date).then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              this.events = resp.data;
              this.resolveEventObject(resp.data);
            }
          });
        }

        const typeParameterValue = urlSearchParams.get('type');
        if(typeParameterValue=='personalCalendar'){
          this.personalCalendar = true;
        }

        if(this.personalCalendar){
          this.events = this.events.filter(data => data.attendees.length > 0);
        }

        this.calendardialogLoader = false;

      },
      resolveEventObject(calendarObject){
        const events = []
        const keysToModify = ['start', 'end'];
        const keyStatusToModify = ['attendees'];

        for (const eventObjKey in calendarObject){
          const newEventList = {};
          for (const key in calendarObject[eventObjKey]) {
            if (key=='subject') {
              newEventList['name'] = calendarObject[eventObjKey][key];
            }
            if(key=='isAllDay') {
              newEventList['timed'] = calendarObject[eventObjKey][key];
            }
            if(key=='singleValueExtendedProperties'){
              let color = this.extractCalendarColor(calendarObject[eventObjKey][key]['calendarId']);
              newEventList['calendarId'] = calendarObject[eventObjKey][key]['calendarId'];
              newEventList['calendarColor'] = color;
              newEventList['calendartype'] = this.extractCalendarType(calendarObject[eventObjKey][key]['calendarId']);
              newEventList['calendarName'] = this.extractCalendarName(calendarObject[eventObjKey][key]['calendarId']);
              newEventList['color'] = color?color:'blue';
            }
            if (keysToModify.includes(key)) {
              newEventList[key] = this.convertToDate(calendarObject[eventObjKey][key]);
            } 
            else if (keyStatusToModify.includes(key)) {
              newEventList['response_status'] = this.checkforStatus(calendarObject[eventObjKey][key]);
              newEventList[key] = calendarObject[eventObjKey][key];
            } 
            else{
              newEventList[key] = calendarObject[eventObjKey][key];
            }
          }
          events.push(newEventList)
        }
        this.events = events;
      },
      convertToDate(input){
        const output = new Date(input.dateTime);
        return output;
      },
      formatDate(date) {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      },
      convertDate(date){
        var dateFormat =new Date(date);
        const options = { month: "short"}

        return (dateFormat.getDate()+
            " "+(dateFormat.toLocaleDateString(this.currentUser.lang_code, options))+
            " "+dateFormat.getFullYear());

      },
      getCalendarDate(dateString) {
          const monthNames = [
              'January', 'February', 'March', 'April', 'May', 'June',
              'July', 'August', 'September', 'October', 'November', 'December'
          ];
          const [month, year] = dateString.split(' '); //for cross browser compatibility we need to splits the input string into the month and year parts,
          const monthIndex = monthNames.findIndex(m => m.toLowerCase() === month.toLowerCase());

          if (monthIndex === -1) {
              return null; //Invalid month name
          }

          const formattedDate = new Date(year, monthIndex);
          const options = {
              year: 'numeric',
              month: 'long',
          };
          return formattedDate.toLocaleDateString(this.currentUser.lang_code, options);
      },
      getCalendarName(calendarName){
          if(!calendarName) return ;
          const regex = /^(.*?)\([^)]+\)$/;
          // Use the replace method to remove words within parentheses
          const result = calendarName.replace(regex, '$1');
          return result.trim(); 
      },
      extractCalendarName(calendarId){
        for (const calendar of this.calendars) {
          if (calendar.id === calendarId) {
            return calendar.name;
          }
        }
        return "";
      },
      extractCalendarType(calendarId){
        for (const calendar of this.calendars) {
          if (calendar.id === calendarId) {
            return calendar.singleValueExtendedProperties.calendar_type;
          }
        }
        return "";
      },
      extractCalendarColor(calendarId){
        for (const calendar of this.calendars) {
          if (calendar.id === calendarId) {
            return calendar.hexColor;
          }
        }
        // Return a default color or handle the case where the calendar ID is not found
        return "#0078d4";
      },
      viewDay ({ date }) {
        this.lmscalendar = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.lmscalendar = ''
      },
      prev () {
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }
        nativeEvent.stopPropagation()
      },
      filterMyEvents(){
        if(this.personalCalendar){
          this.allEventsCalendar = false;
          this.personalCalendar = true;
          this.events = this.events.filter(data => data.attendees.length > 0);
        }
        else{
          this.allEventsCalendar = true;
          this.personalCalendar = false;
          this.calendarsUpdated();
        }
      },
      checkforStatus(attendeeList){
        if (Array.isArray(attendeeList) && attendeeList.length > 0) {
          const containsObject = attendeeList.some(item => typeof item === "object");

          if (containsObject) {
            return attendeeList[0].status.response;
          }
          else{
            return false;
          }
        }
      },
      openParticipationCountModal(event){
        this.attendee_limit = null;
        this.ms_event_id = event.id;
        this.ms_event = event;
        this.selectedOpen = false;
        this.participationDialog = true;
      },
      async addAttendeeLimit(all_series){
        this.isLoading = true;
        let params = {
            ms_event_id: this.ms_event_id,
            attendee_limit: this.attendee_limit,
        };

        if(all_series){
          params['for_all_series']= true;
        }
        else{
          params['for_all_series']= false;
        }

        await this.$store
        .dispatch(ADD_ATTENDEE_LIMIT, params).then(resp => {
          if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
            this.participationDialog = false;
            store.commit(SET_SNACKBAR, {
                status: true,
                message: "Participation Limit Added",
            });
            this.$store.commit(SET_LOADING, false)
            this.isLoading = false;
          }
        });
      },
      isOpenEvent(event){
        // Get the current date
        const currentDate = new Date();
        // Set the time portion of currentDate to midnight (00:00:00)
        currentDate.setHours(0, 0, 0, 0);
        // Create Date objects from the provided start and end dates
        const startDateObj = new Date(event.start);
        return(currentDate<=startDateObj);
      },
      checkAlreadyAdded(event){
        if(event.hasOwnProperty('singleValueExtendedProperties')){
          return event.singleValueExtendedProperties.attendee_limit ? true : false
        }
        return false;
      }
    }
}
</script>

<style scoped>
.custom-button {
  display: inline-block;
  padding: 10px 20px; /* Adjust padding as needed */
  color: white; /* Set text color */
  border-radius: 5px; /* Add rounded corners */
  cursor: default; /* Prevent the button from being clickable */
}

.accepted-button{
  background-color: green; /* Set your desired background color */
}

.declined-button{
  background-color: rgb(128, 0, 0); /* Set your desired background color */
}
</style>
